import { HelmetDexteel } from "@dexteel/mesf-core";
import { Stack, Typography } from "@mui/material";

import { ChemistryRangesPage } from "@/pages/configuration/pages/chemistry-ranges/ChemistryRangesPage";
import { pageBgColor } from "@/utils/theme";

export const ChemistryRangesSpecPage = () => (
	<>
		<HelmetDexteel title="Chemistry Ranges" />
		<Stack
			spacing={1}
			sx={{ backgroundColor: pageBgColor, px: 2, pt: 2, pb: 1 }}
		>
			<Stack direction="column" spacing={1} alignItems="baseline">
				<Typography variant="h5" fontWeight={600}>
					Chemistry Ranges
				</Typography>
			</Stack>

			<ChemistryRangesPage readOnly />
		</Stack>
	</>
);
